export function logInfo(...args: any[]) {
    console.log(...args) // eslint-disable-line no-console
}
